(() => {
  if (window.__ossFootballBootsHubInstalled) return;
  window.__ossFootballBootsHubInstalled = true;

  const MOBILE_QUERY = '(max-width: 767px)';
  const PAGE_SIZE = 48;
  const BRANDS = [
    { key: 'adidas', label: 'Adidas' },
    { key: 'nike', label: 'Nike' },
    { key: 'puma', label: 'Puma' }
  ];
  const SURFACE_ORDER = ['all', 'new', 'fg', 'sg', 'ag', 'turf', 'indoor'];

  const state = {
    surface: 'all',
    brand: null,
    player: null
  };

  let lastMobile = window.matchMedia(MOBILE_QUERY).matches;
  let loadPromise = null;

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;
  const getRoot = () => document.querySelector('.oss-boots-custom-template');
  const getCards = () => Array.from(document.querySelectorAll('.oss-boots-custom-template .oss-boots-product-card'));
  const isQuickActive = () => state.surface !== 'all' || !!state.brand || !!state.player;
  const formatProducts = (count) => `${count} product${count === 1 ? '' : 's'}`;

  const getTotalCount = () => {
    const summary = document.querySelector('[data-oss-results-summary]');
    return Number(summary?.dataset.ossTotalCount || 0);
  };

  const cardKey = (card) => {
    const link = card.querySelector('.product-block__title-link, .product-block__image');
    return (link?.getAttribute('href') || '').split('?')[0];
  };

  const cardTitle = (card) => String(card.querySelector('.product-block__title-link')?.textContent || '').trim().toLowerCase();

  const cardBrand = (card) => {
    const title = cardTitle(card);
    const vendor = String(card.querySelector('.product-block__vendor')?.textContent || '').trim().toLowerCase();

    if (title.includes('nike')) return 'nike';
    if (title.includes('adidas')) return 'adidas';
    if (title.includes('puma')) return 'puma';
    if (vendor.includes('nike')) return 'nike';
    if (vendor.includes('adidas')) return 'adidas';
    if (vendor.includes('puma')) return 'puma';
    return '';
  };

  const decorateSurfaceClasses = (card) => {
    if (!card || card.dataset.ossSurfaceDecorated === 'true') return;
    const title = cardTitle(card);
    const hasFgSg = /\bfg\s*[\/-]\s*sg\b/i.test(title);
    const hasSg = hasFgSg || /\bsg\b/i.test(title) || title.includes('soft ground');

    if (hasFgSg) card.classList.add('oss-surface-fg');
    if (hasSg) card.classList.add('oss-surface-sg');
    card.dataset.ossSurfaceDecorated = 'true';
  };

  const matchesSurface = (card) => {
    if (state.surface === 'all') return true;
    if (state.surface === 'new') return card.classList.contains('oss-surface-new');
    return card.classList.contains(`oss-surface-${state.surface}`);
  };

  const matchesBrand = (card) => {
    if (!state.brand) return true;
    return cardBrand(card) === state.brand;
  };

  const matchesPlayer = (card) => {
    if (!state.player) return true;
    if (state.player === 'limited') return card.classList.contains('oss-limited-edition');
    return card.classList.contains(`oss-player-${state.player}`);
  };

  const ensureSurfaceOrder = () => {
    const root = getRoot();
    const allButton = root?.querySelector('[data-oss-surface-filter="all"]');
    const row = allButton?.closest('.oss-boots-filter-row');
    if (!row) return;

    if (!row.querySelector('[data-oss-surface-filter="sg"]')) {
      const sgButton = document.createElement('button');
      sgButton.type = 'button';
      sgButton.className = 'oss-boots-filter-chip';
      sgButton.dataset.ossSurfaceFilter = 'sg';
      sgButton.setAttribute('aria-pressed', 'false');
      sgButton.innerHTML = `
        <span class="oss-boots-filter-chip__icon" aria-hidden="true">
          <svg viewBox="0 0 32 32"><path d="M5 25h22M8 23l2-13 3 13M14 23l2-16 3 16M21 23l3-13"/><path d="M9 10h3M15 7h3M23 10h2"/></svg>
        </span>
        <span>SG</span>
        <small>Soft Ground</small>`;
      row.appendChild(sgButton);
    }

    const desired = SURFACE_ORDER
      .map((surface) => row.querySelector(`[data-oss-surface-filter="${surface}"]`))
      .filter(Boolean);
    const current = Array.from(row.children).filter((child) => child.matches('[data-oss-surface-filter]'));
    const alreadyOrdered = desired.length === current.length && desired.every((button, index) => current[index] === button);

    if (!alreadyOrdered) desired.forEach((button) => row.appendChild(button));
  };

  const ensureBrandFilter = () => {
    const root = getRoot();
    const quickFilters = root?.querySelector('.oss-boots-quick-filters');
    if (!quickFilters || quickFilters.querySelector('[data-oss-brand-group]')) return;

    const groups = Array.from(quickFilters.querySelectorAll(':scope > .oss-boots-filter-group'));
    const brandGroup = document.createElement('div');
    brandGroup.className = 'oss-boots-filter-group';
    brandGroup.dataset.ossBrandGroup = 'true';

    const heading = document.createElement('div');
    heading.className = 'oss-boots-filter-group__heading';
    heading.textContent = 'Select Brand';

    const row = document.createElement('div');
    row.className = 'oss-boots-filter-row oss-boots-filter-row--players oss-boots-filter-row--brands';
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', 'Select Brand');

    BRANDS.forEach((brand) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'oss-boots-player-chip oss-boots-player-chip--limited oss-boots-brand-chip';
      button.dataset.ossBrandFilter = brand.key;
      button.setAttribute('aria-pressed', 'false');
      button.textContent = brand.label;
      row.appendChild(button);
    });

    brandGroup.append(heading, row);
    quickFilters.insertBefore(brandGroup, groups[1] || null);
  };

  const accordionSlug = (label, index) => {
    const slug = String(label || `group-${index + 1}`)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return slug || `group-${index + 1}`;
  };

  const syncAccordionViewport = () => {
    const root = getRoot();
    if (!root) return;

    root.querySelectorAll('[data-oss-mobile-accordion]').forEach((group) => {
      const trigger = group.querySelector(':scope > [data-oss-accordion-trigger]');
      if (!trigger) return;

      if (!isMobile()) {
        group.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        return;
      }

      const open = group.dataset.ossAccordionOpen === 'true';
      group.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  };

  const ensureMobileAccordions = () => {
    if (!isMobile()) return;

    const root = getRoot();
    const quickFilters = root?.querySelector('.oss-boots-quick-filters');
    if (!quickFilters) return;

    const groups = Array.from(quickFilters.querySelectorAll(':scope > .oss-boots-filter-group'));

    groups.forEach((group, index) => {
      let heading = group.querySelector(':scope > .oss-boots-filter-group__heading');
      const row = group.querySelector(':scope > .oss-boots-filter-row');
      if (!heading || !row) return;

      const existingLabel = heading.dataset.ossAccordionLabel || heading.textContent.trim();
      let trigger = heading;

      if (!heading.matches('[data-oss-accordion-trigger]')) {
        trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = `${heading.className} oss-boots-accordion-trigger`;
        trigger.dataset.ossAccordionTrigger = 'true';
        trigger.dataset.ossAccordionLabel = existingLabel;

        const label = document.createElement('span');
        label.className = 'oss-boots-accordion-label';
        label.textContent = existingLabel;

        const chevron = document.createElement('span');
        chevron.className = 'oss-boots-accordion-chevron';
        chevron.setAttribute('aria-hidden', 'true');

        trigger.append(label, chevron);
        heading.replaceWith(trigger);
        heading = trigger;
      }

      const slug = accordionSlug(existingLabel, index);
      const panelId = row.id || `oss-boots-accordion-${slug}`;
      row.id = panelId;
      row.dataset.ossAccordionPanel = 'true';
      trigger.setAttribute('aria-controls', panelId);
      group.dataset.ossMobileAccordion = 'true';

      if (group.dataset.ossAccordionInitialized !== 'true') {
        group.dataset.ossAccordionInitialized = 'true';
        group.dataset.ossAccordionOpen = 'false';
      }
    });

    syncAccordionViewport();
  };

  const updateCount = (visible) => {
    const quickActive = isQuickActive();

    document.querySelectorAll('[data-oss-results-summary]').forEach((node) => {
      const total = Number(node.dataset.ossTotalCount || 0);
      node.textContent = formatProducts(quickActive ? visible : total);
    });

    document.querySelectorAll('[data-oss-quick-count]').forEach((node) => {
      node.textContent = isMobile() ? '' : (quickActive ? `${visible} matching products` : '');
    });
  };

  const setLoadingCount = () => {
    document.querySelectorAll('[data-oss-results-summary]').forEach((node) => {
      node.textContent = 'Filtering…';
    });
  };

  const updateButtons = () => {
    document.querySelectorAll('[data-oss-surface-filter]').forEach((button) => {
      const active = button.dataset.ossSurfaceFilter === state.surface;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    document.querySelectorAll('[data-oss-brand-filter]').forEach((button) => {
      const active = button.dataset.ossBrandFilter === state.brand;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    document.querySelectorAll('[data-oss-player-filter]').forEach((chip) => {
      chip.classList.add('oss-boots-player-chip--limited');
      const active = chip.dataset.ossPlayerFilter === state.player;
      chip.classList.toggle('is-active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const updatePagination = () => {
    const root = getRoot();
    if (!root) return;
    root.querySelectorAll('.pagination').forEach((pagination) => {
      pagination.hidden = isQuickActive();
    });
  };

  const applyQuickFilters = () => {
    ensureSurfaceOrder();
    ensureBrandFilter();
    ensureMobileAccordions();
    const cards = getCards();
    if (!cards.length) return;

    const quickActive = isQuickActive();
    let visible = 0;

    cards.forEach((card) => {
      decorateSurfaceClasses(card);
      const extraCard = card.dataset.ossQuickExtra === 'true';
      const canParticipate = !extraCard || quickActive;
      const show = canParticipate && matchesSurface(card) && matchesBrand(card) && matchesPlayer(card);
      card.classList.toggle('oss-boots-filter-hidden', !show);
      if (show) visible += 1;
    });

    updateButtons();
    updateCount(visible);
    updatePagination();

    document.querySelectorAll('[data-oss-no-quick-results]').forEach((node) => {
      node.textContent = 'No products match the selected filters.';
      node.hidden = visible !== 0;
    });
  };

  const ensureAllQuickCards = async () => {
    if (!isQuickActive()) return;

    const root = getRoot();
    const grid = root?.querySelector('[data-oss-boots-grid]');
    const total = getTotalCount();
    if (!root || !grid || total <= 0) return;

    if (getCards().length >= total) return;
    if (loadPromise) return loadPromise;

    loadPromise = (async () => {
      const sourceUrl = new URL(window.location.href);
      const currentPage = Number(sourceUrl.searchParams.get('page') || '1');
      const totalPages = Math.ceil(total / PAGE_SIZE);
      const pageNumbers = [];

      for (let page = 1; page <= totalPages; page += 1) {
        if (page !== currentPage) pageNumbers.push(page);
      }

      const responses = await Promise.all(pageNumbers.map(async (pageNumber) => {
        const url = new URL(sourceUrl.toString());
        url.searchParams.set('page', String(pageNumber));
        url.searchParams.set('section_id', root.dataset.sectionId);

        const response = await fetch(url.toString(), {
          method: 'GET',
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) return [];
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.from(doc.querySelectorAll('.oss-boots-product-card'));
      }));

      const existingKeys = new Set(getCards().map(cardKey).filter(Boolean));

      responses.flat().forEach((card) => {
        const key = cardKey(card);
        if (key && existingKeys.has(key)) return;
        if (key) existingKeys.add(key);
        decorateSurfaceClasses(card);
        card.dataset.ossQuickExtra = 'true';
        card.classList.add('oss-boots-filter-hidden');
        grid.appendChild(card);
      });
    })().catch((error) => {
      console.warn('[OneSportyStore] Could not load all Football Boots quick-filter pages.', error);
    }).finally(() => {
      loadPromise = null;
    });

    return loadPromise;
  };

  const runQuickFilter = async () => {
    ensureSurfaceOrder();
    ensureBrandFilter();
    ensureMobileAccordions();
    updateButtons();
    if (isQuickActive()) {
      setLoadingCount();
      await ensureAllQuickCards();
    }
    applyQuickFilters();
  };

  const openCombinedPanel = () => {
    const root = getRoot();
    if (!root) return;
    const filterTrigger = root.querySelector('.cc-filters-control .js-show-filters');
    const sortTrigger = root.querySelector('.cc-filters-control .js-show-sort');
    const trigger = filterTrigger || sortTrigger;
    if (trigger) trigger.click();
  };

  document.addEventListener('click', async (event) => {
    const accordionTrigger = event.target.closest('[data-oss-accordion-trigger]');
    if (accordionTrigger && isMobile()) {
      event.preventDefault();
      const group = accordionTrigger.closest('[data-oss-mobile-accordion]');
      if (group) {
        const open = group.dataset.ossAccordionOpen === 'true';
        group.dataset.ossAccordionOpen = open ? 'false' : 'true';
        syncAccordionViewport();
      }
      return;
    }

    const combinedButton = event.target.closest('[data-oss-filter-sort-trigger]');
    if (combinedButton) {
      event.preventDefault();
      openCombinedPanel();
      return;
    }

    const brandChip = event.target.closest('[data-oss-brand-filter]');
    if (brandChip) {
      event.preventDefault();
      const brand = brandChip.dataset.ossBrandFilter || null;
      state.brand = state.brand === brand ? null : brand;
      await runQuickFilter();
      return;
    }

    const playerChip = event.target.closest('[data-oss-player-filter]');
    if (playerChip) {
      event.preventDefault();
      const player = playerChip.dataset.ossPlayerFilter || null;
      state.player = state.player === player ? null : player;
      await runQuickFilter();
      return;
    }

    const surfaceButton = event.target.closest('[data-oss-surface-filter]');
    if (surfaceButton) {
      event.preventDefault();
      state.surface = surfaceButton.dataset.ossSurfaceFilter || 'all';
      await runQuickFilter();
    }
  });

  const handleViewportChange = () => {
    const mobile = isMobile();
    if (mobile === lastMobile) return;

    lastMobile = mobile;
    if (mobile) {
      document.querySelectorAll('[data-oss-mobile-accordion]').forEach((group) => {
        group.dataset.ossAccordionOpen = 'false';
      });
    }
    syncAccordionViewport();
    applyQuickFilters();
  };

  const init = () => {
    ensureSurfaceOrder();
    ensureBrandFilter();
    ensureMobileAccordions();
    applyQuickFilters();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('resize', handleViewportChange, { passive: true });

  const observer = new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) return;

    window.requestAnimationFrame(async () => {
      ensureSurfaceOrder();
      ensureBrandFilter();
      ensureMobileAccordions();
      if (isQuickActive() && getCards().length < getTotalCount()) {
        await ensureAllQuickCards();
      }
      applyQuickFilters();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
